import React, { ChangeEvent, useEffect, useState } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import SvgSearch from '../../svg/Search';
import axios from '../../api/axios';
import { ITenant, IContact, IPhoto, ERepositoryPage } from '../../pages/types';
import './Header.css';
import Search from '../search/Search';
import { translate } from '../../i18n';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useParams } from 'react-router-dom';

interface IHeaderProps {}

const Header: React.FC<IHeaderProps> = (props) => {
    const [input, setInput] = useState('');
    const [isKeyboardHidden, setIsKeyboardHidden] = useState(true);
    const [photo, SetPhoto] = useState<IPhoto>();

    const params = useParams();
    const { BuildingId } = useSelector((state: RootState) => state.buildingId);

    const { language } = useSelector((state: RootState) => state.lang);
    const [contactSeach, setContactSearch] = useState<IContact[]>(new Array<IContact>());
    const [tenantSearch, setTenantSearch] = useState<ITenant[]>(new Array<ITenant>());

    var onChange = (inputs: string | ChangeEvent<HTMLInputElement>): void => {
        if (typeof input === 'string') {
            setInput(inputs as string);
        } else {
            const query = inputs as ChangeEvent<HTMLInputElement>;
            setInput(query.target.value);
        }
    };
    const ShowKeyboard = () => {
        setIsKeyboardHidden(!isKeyboardHidden);
    };

    const GET_CONTACTS_URL = '/api/hblogin/repository/GetContactsByBuildingId';
    const GET_TENANTS_URL = '/api/hblogin/repository/GetLocatairesByBuildingId';
    const GET_IMAGES_URL = '/api/hblogin/repository/GetImagesByBuildingId';

    useEffect(() => {
        axios.get<ITenant[]>(`${GET_TENANTS_URL}`, { params: { buildingId: BuildingId } }).then((response) => setTenantSearch(response.data));
        axios.get<IContact[]>(`${GET_CONTACTS_URL}`, { params: { buildingId: BuildingId } }).then((response) => setContactSearch(response.data));
        axios
            .get<IPhoto[]>(`${GET_IMAGES_URL}`, { params: { id: BuildingId } })
            .then((reponse) => reponse.data)
            .then((photos) => {
                let logo = photos.filter((photo) => photo.repositoryPage == ERepositoryPage.logo)[0];
                SetPhoto(logo);
            });
    }, []);

    return (
        <div className="HeaderOuter ">
            <div className="HeaderInner">
                <div className="HeaderLogo Drop-Shadow">
                    <div className="HeaderLogoInner">
                        <img width="228px" height="40px" src={language === 'EN' ? photo?.urlEnglishHorizontal : photo?.urlFrenchHorizontal} alt="logo" />
                    </div>
                </div>
                <input className="HeaderSearch Drop-Shadow" type="text" placeholder={translate('Search', language)} value={input} onChange={onChange} onFocus={ShowKeyboard} id="header-search" />
                <button className="HeaderSearchBtn Drop-Shadow" type="submit">
                    <SvgSearch width={'50%'} height={'50%'} color="#FFFFFF" />
                </button>
                <div id="Keyboard" className="Drop-Shadow" hidden={isKeyboardHidden}>
                    <button id="Close" onClick={ShowKeyboard}>
                        X
                    </button>
                    <Keyboard onChange={onChange} />
                </div>
                {!isKeyboardHidden && <Search query={input} contacts={contactSeach} tenants={tenantSearch} click={setIsKeyboardHidden} />}
            </div>
        </div>
    );
};

export default Header;
